export const formatCurrency = (amount: number): string =>
  `${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} Kč`;

export const truncateName = (name: string, length: number): string => {
  if (name.length >= length) {
    return name.substr(0, length) + "...";
  } else {
    return name;
  }
};
